import { useCallback, useEffect, useState } from 'react';

import constants from '../constants';
import { noop } from 'lodash';

const useMessageQueue = (
  initialMessages = [],
  displayDuration = constants.MILLISECONDS_PER_TICK *
    constants.TOAST_VISIBILITY_IN_TICKS,
) => {
  const [messageQueue, setMessageQueue] = useState(initialMessages);

  useEffect(() => {
    if (messageQueue.length > 0) {
      const timer = setTimeout(() => setMessageQueue([]), displayDuration);
      return () => clearTimeout(timer);
    }
    return () => noop;
  }, [messageQueue, displayDuration]);

  const addMessage = useCallback(
    message => setMessageQueue(queue => [...queue, message]),
    [messageQueue],
  );

  return { messageQueue, addMessage };
};

export default useMessageQueue;
